// extracted by mini-css-extract-plugin
export var mainList = "footer-module--main-list--07d2d";
export var subtitle = "footer-module--subtitle--ea523";
export var title = "footer-module--title--ef13d";